import React from 'react'
var noimage = (window as any).noimage;
const noImageHandling = ({ currentTarget }: any) => {
    currentTarget.onerror = null; // prevents looping
    currentTarget.src = noimage;
}
const SubDepartments = (props: any) => {
    return (
        <div className="col-md-12 top65 outer-scroll">
            <div className="d-flex cat-row flex-wrap">
                {
                    props?.childDeps ? <>
                        {
                            props?.childDeps.map((dep: any, index: number) => {
                                return (<a href={dep.searchUrl} className="col sub-cat" key={`child-${dep.departmentID}`}>
                                    {/*<div className="image">*/}
                                    {/*    <img className="d-block mx-auto display-img" src={dep.headerImage ?? noimage} onError={noImageHandling}  alt={dep.name} />*/}
                                    {/*</div>*/}
                                    <div className="cat-title">{dep.name}</div>
                                </a>)
                            })
                        }
                    </> : ''
                }
            </div>
        </div>

    )
}
export default SubDepartments;
